import type {
  BusinessCreateProfilePayload,
  CreateProfilePayload,
  IndividualCreateProfilePayload,
  SoleTraderCreateProfilePayload,
} from "../types/createProfile.type";
import { CreateProfileType } from "../types/createProfile.type";

export interface CreateProfileModalFormValues {
  profileName: string;
  profileType: CreateProfileType;
  legalName: string;
  tradingName?: string;
}

const businessProfileTypes: CreateProfileType[] = [
  CreateProfileType.trust,
  CreateProfileType.company,
  CreateProfileType.plc,
  CreateProfileType.partnership,
  CreateProfileType.otherEntity,
];

export const buildCreateProfileModalPayload = (
  values: CreateProfileModalFormValues
): CreateProfilePayload => {
  const { profileName, profileType, legalName, tradingName } = values;

  if (profileType === CreateProfileType.individual) {
    const individualPayload: IndividualCreateProfilePayload = {
      name: profileName,
      type: CreateProfileType.individual,
      details: {
        legalName,
        aliases: [],
        dateOfBirth: null,
        countryCode: null,
        email: null,
        contactName: null,
      },
      source: "app",
    };
    return individualPayload;
  }

  if (profileType === CreateProfileType.soleTrader) {
    const soleTraderPayload: SoleTraderCreateProfilePayload = {
      name: profileName,
      type: CreateProfileType.soleTrader,
      details: {
        legalName,
        tradingName: tradingName ?? "",
        aliases: [],
        dateOfBirth: null,
        email: null,
        activity: null,
        countryCode: null,
        contactName: null,
      },
      source: "app",
    };
    return soleTraderPayload;
  }

  if (businessProfileTypes.includes(profileType)) {
    const businessPayload: BusinessCreateProfilePayload = {
      name: profileName,
      type: profileType as BusinessCreateProfilePayload["type"],
      details: {
        legalName,
        aliases: [],
      },
      source: "app",
    };
    return businessPayload;
  }

  throw new Error("Invalid profile type for create profile modal");
};
